import { render, staticRenderFns } from "./demo_delete_form.vue?vue&type=template&id=f0bf6f66&"
import script from "./demo_delete_form.vue?vue&type=script&lang=js&"
export * from "./demo_delete_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports